module.exports = __webpack_public_path__ + "static/media/Relative-Medium-Web.63b67109.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Relative-Medium-Web.ttf
// module id = 746
// module chunks = 0